class StepsShowcaseMto extends HTMLElement {
  connectedCallback() {
    this.labels = Array.from(this.querySelectorAll('[data-step-label]'));
    this.images = Array.from(this.querySelectorAll('[data-step-image]'));

    this.labels.forEach((label) => {
      label.addEventListener('click', this.onLabelClick.bind(this));
    });
  }

  onLabelClick(event) {
    this.setActive(event.currentTarget.dataset.stepLabel);
  }

  setActive(index) {
    this.labels.forEach((label) => {
      const isActive = label.dataset.stepLabel === index;
      label.classList.toggle('active', isActive);
      label.setAttribute('aria-pressed', String(isActive));
    });
    this.images.forEach((image) => {
      image.classList.toggle('active', image.dataset.stepImage === index);
    });
  }
}

customElements.define('steps-showcase-mto', StepsShowcaseMto);
